import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';

import { Attendance } from '../../models/attendance.school.model';
import * as attendanceActions from '../actions/attendance.school.actions';

export interface AttendanceState extends EntityState<Attendance> {
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  attendanceStatsLoading: boolean;
  error: AppExceptionModel | undefined;
}

export const attendanceAdapter: EntityAdapter<Attendance> =
  createEntityAdapter<Attendance>();

export const initialState: AttendanceState = attendanceAdapter.getInitialState({
  loading: false,
  loaded: false,
  inProgress: false,
  attendanceStatsLoading: false,
  error: undefined,
});

export const schoolAttendanceReducer = createReducer(
  initialState,
  on(attendanceActions.getAttendances, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(attendanceActions.getAttendance, (state, {}) => ({
    ...state,
    error: undefined,
  })),
  on(attendanceActions.addAttendanceToStore, (state, { attendance }) =>
    attendanceAdapter.upsertOne(attendance, {
      ...state,
      error: undefined,
      loading: false,
      loaded: true,
    }),
  ),
  on(attendanceActions.addAttendancesToStore, (state, { attendances }) => {
    return attendanceAdapter.upsertMany(attendances, {
      ...state,
      loading: false,
      loaded: true,
      inProgress: false,
      error: undefined,
    });
  }),
  on(attendanceActions.getAttendancesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(attendanceActions.update, (state, { attendance }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(attendanceActions.updateSuccess, (state) => ({
    ...state,
    error: undefined,
    inProgress: false,
  })),
  on(attendanceActions.updateFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(attendanceActions.deleteAction, (state, { id }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(attendanceActions.deleteSuccess, (state, { id }) =>
    attendanceAdapter.removeOne(id, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(attendanceActions.deleteFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(attendanceActions.getAttendanceStats, (state) => ({
    ...state,
    attendanceStatsLoading: true,
  })),
  on(attendanceActions.getAttendanceStatsDone, (state) => ({
    ...state,
    attendanceStatsLoading: false,
  })),
  on(attendanceActions.getAttendanceStatsFailure, (state) => ({
    ...state,
    attendanceStatsLoading: false,
  })),
  on(attendanceActions.clear, (state) => initialState),
);
